import Vue from 'vue';
import types from './mutation-types';

const mutations = {
  [types.MAKE_CARD_PRIVATE](state, cardId) {
    state.myCardList.forEach((card, i) => {
      if (card.id === cardId) {
        Vue.set(state.myCardList[i], 'share_level', 2);
      }
    });
  },

  [types.MAKE_CARD_PUBLIC](state, cardId) {
    state.myCardList.forEach((card, i) => {
      if (card.id === cardId) {
        Vue.set(state.myCardList[i], 'share_level', 1);
      }
    });
  },

  [types.SET_CARD_SHARE_LEVEL](state, { cardId, shareLevel }) {
    state.myCardList.forEach((card, i) => {
      if (card.id === cardId) {
        Vue.set(state.myCardList[i], 'share_level', shareLevel);
      }
    });
  },

  [types.UPDATE_CARD](state, updatedCard) {
    state.myCardList.forEach((card, i) => {
      if (card.id === updatedCard.id) {
        Vue.set(state.myCardList, i, updatedCard);
      }
    });
  },

  [types.REMOVE_CARD](state, cardId) {
    state.myCardList.forEach((card, i) => {
      if (card.id === cardId) {
        Vue.delete(state.myCardList, i);
      }
    });
  },

  [types.SET_CARDS](state, cardList) {
    Vue.set(state, 'myCardList', cardList);
  },

  [types.ADD_CARDS](state, cardList) {
    state.myCardList.push(...cardList);
  },

  [types.SET_CARD_PAGES](state, { cardId, pageList }) {
    state.myCardList.forEach((card) => {
      if (card.id === cardId) {
        Vue.set(card, 'pages', pageList);
      }
    });
  },

  [types.SET_CARD_COVER_IMAGE](state, { cardId, coverImage }) {
    state.myCardList.forEach((card) => {
      if (card.id === cardId) {
        Vue.set(card, 'cover_image', coverImage);
      }
    });
  },

  [types.ADD_SELECTED_PAGE](state, page) {
    state.selectedPageList.push(page);
  },

  [types.REMOVE_SELECTED_PAGE](state, index) {
    state.selectedPageList.splice(index, 1);
  },

  [types.RESET_SELECTED_PAGE](state) {
    Vue.set(state, 'selectedPageList', []);
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/my-cards/store/mutations.js